module.exports = __webpack_public_path__ + "img/Tribo2.ba0607a8.webp";